import Props from './typings';
import {StyledTooltip, StyledTooltipContainer} from './styles';
import useReposition from '../../../hooks/use-reposition/use-reposition';

const Tooltip = ({position = 'top', text, children}: Props) => {
  const tooltip = useReposition(position, document.body, 10);

  return (
    <StyledTooltipContainer $position={tooltip.position} $offsetBy={tooltip.offset}>
      <StyledTooltip role="tooltip" ref={tooltip.ref}>
        {text}
      </StyledTooltip>
      {children}
    </StyledTooltipContainer>
  );
};

export default Tooltip;
